import { isEmpty } from 'lodash';

const removeEmptyFeaturedOffer = featuredOffers => featuredOffers?.filter?.(item => !isEmpty(item.offer));

export { removeEmptyFeaturedOffer };
